import React from "react";
import Box from "@mui/material/Box/Box";
import { Badge, Button, Chip, IconButton, useMediaQuery } from "@mui/material";
import GenieLogo from "../../../../components/special/genie-logo/GenieLogo";
import GenieProfile from "../../../../components/special/genie-login-button/GenieProfile";
import { ArrowRight, ShoppingCart } from "@mui/icons-material";
import { theme } from "../../../../components/special/genie-theme/genie-theme";
import { useNavigate, useParams } from "react-router-dom";
import GenieText from "../../../../components/core/genie-text/GenieText";
import useUser from "../../../../queries/routes/useUser";
import useCurrentCart from "../../../../queries/routes/useCurrentCart";

interface StorefrontHeaderProps {
  openDrawer: () => void;
}

function StorefrontHeader(props: StorefrontHeaderProps) {

  const { openDrawer } = props;
  const { data: user } = useUser();
  const navigate = useNavigate();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { org_id } = useParams<{ org_id: string }>();
  const { data: cart } = useCurrentCart(org_id!, user?.organizations[0].id!);

  const userType = user?.organizations[0].selected_type;
  const lineItems =
    cart?.line_items
      .map((li) => li.quantity)
      .reduce((acc, li) => acc + li, 0) || 0;

  return (
    <Box
      position={"sticky"}
      top={0}
      py={2}
      px={isMobile ? 2 : 4}
      borderBottom={1}
      sx={{
        backgroundColor: theme.palette.common.white,
        backdropFilter: "blur(20px)",
        zIndex: 1100,
        borderColor: "grey.300",
      }}
    >
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Box display={"flex"} alignItems={"center"}>
          <GenieLogo />
          {userType !== "Buyer" && (
            <Chip
              sx={{ ml: 2 }}
              label="Admin"
              color={"warning"}
              variant={"outlined"}
              onClick={() => navigate("/")}
            />
          )}
        </Box>
        <Box display={"flex"} alignItems={"center"}>
          <GenieProfile isOnlyLogo={true} />
          {isMobile ? (
            <IconButton
              aria-label="cart"
              size="small"
              color={"primary"}
              sx={{ ml: 1 }}
              onClick={openDrawer}
            >
              <Badge badgeContent={lineItems} color="primary">
                <ShoppingCart />
              </Badge>
            </IconButton>
          ) : (
            <Badge badgeContent={lineItems} color="primary">
              <Button
                size={"large"}
                sx={{ ml: 1 }}
                variant="outlined"
                startIcon={<ShoppingCart />}
                endIcon={<ArrowRight />}
                onClick={openDrawer}
              >
                Cart
              </Button>
            </Badge>
          )}
          <Box ml={1} display={"flex"} alignItems={"center"}>
            <GenieText
              link={`/storefront/${org_id}/orders`}
              fontSize={"tiny"}
              underline
            >
              Orders
            </GenieText>
          </Box>
          <GenieText
            link={`/logout`}
            style={{ cursor: "pointer", ml: 2 }}
            fontSize={"tiny"}
            underline
          >
            Log Out
          </GenieText>
        </Box>
      </Box>
    </Box>
  );
}

export default StorefrontHeader;
